import { Controller } from "@hotwired/stimulus"

// Opens a native <dialog> element when content is loaded into the modal turbo frame.
// Closes on Escape (native), backdrop click, or explicit close action.
export default class extends Controller {
  connect() {
    this.element.showModal()
    this.element.addEventListener("click", this.handleBackdropClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleBackdropClick)
  }

  close() {
    this.element.close()
  }

  handleBackdropClick = (event) => {
    if (event.target === this.element) {
      this.element.close()
    }
  }
}
